import { useEffect, useState } from 'react';
import { Badge, Tooltip, Typography } from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import { useTranslation } from 'react-i18next';
import { onConnectionChange } from '../lib/dataService';
import { safeElectronCall } from '../lib/util/electronHelpers';

const ConnectionStatus = ({ sx }) => {
  const [online, setOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const [appVersion, setAppVersion] = useState(null);
  const { t } = useTranslation('common');

  useEffect(() => {
    const fetchAppVersion = async () => {
      if (window.electron?.getAppVersion) {
        const appVersionFetch = await safeElectronCall('getAppVersion');
        setAppVersion(appVersionFetch);
      }
    };
    fetchAppVersion();

    const unsubscribe = onConnectionChange((snap) => {
      setOnline(snap.val() === true);
    });
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  if (window.electron) {
    return (
      <>
        <Typography variant="caption" component="div" sx={{ mr: 2, color: 'text.secondary' }}>
          v{appVersion}
        </Typography>

        <Tooltip title={online ? t('status.online') : t('status.offline')}>
          <Badge
            color={online ? 'success' : 'error'}
            variant="dot"
            overlap="circular"
            sx={sx}
          >
            <PublicIcon />
          </Badge>
        </Tooltip>
      </>
    );
  }

  return null;
};

export default ConnectionStatus;
